import { fetchApi } from '@/config/axiosSetting';

import {
  GetBodyCustomerImagesTabsQueryParamsType,
  GetBodyCustomerImagesTabsQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerImagesTabs/getBodyCustomerImagesTabs.type';

export const getBodyCustomerImagesTabsQueryFunction = (
  params: GetBodyCustomerImagesTabsQueryParamsType,
): Promise<GetBodyCustomerImagesTabsQueryResponseType> => {
  return fetchApi.get(`/body/reports/${params.id}/images/customer/entry_tabs/`);
};
